import { ForwardRefExoticComponent, RefAttributes } from "react";
import { TextFieldProps } from "@material-ui/core/TextField";
import CustomSearchAutocomplete, { CustomSearchAutocompleteProps } from "./CustomSearchAutoComplete";
import { TestSpecificationReference } from "../../api/services/TesaTmbApi";
import { CompetitorCompany } from "../../api/services/ProductApi";
import { Laboratory } from "../../api/models/product/Laboratory";
import CustomSearchAutocompleteMultiple, {
  CustomSearchAutocompleteMultipleProps,
} from "./CustomSearchAutocompleteMultiple";
import { UserReferenceResponse } from "../../api/services/UserInfoApi";
import OpportunityProductResponse from "../../api/models/OpportunityProductResponse";
import ProductReferenceResponse from "../../api/models/ProductReferenceResponse";
import { MinimalTestMethod } from "../../pages/Requests/TestTab/testTab.models";
import CountryResponse from "../../api/models/country/Country.response";
import CustomerResponse from "../../api/models/customer/Customer.response";
import UserReferenceDefault from "../../api/models/advanced-search/UserReferenceDefault";
import LaboratoryResponse from "../../api/models/LaboratoryResponse";
import LaboratoryUserResponse from "../../api/models/test-request/LaboratoryUserResponse";
import NartResponse from "../../api/models/product/NartResponse";
import ProductNameResponse from "../../api/models/product/ProductNameResponse";
import BaseProductResponse from "../../api/models/product/BaseProductResponse";
import { NotificationListUserResponse } from "../../api/models/test-request/LaboratoryNotificationLists";
import { CompetitorProductReferenceResponse } from "../../api/models/CompetitorProductReference";
import { PrototypeProductReferenceResponse } from "../../api/models/PrototypeProductReference";

type Oem = TestRequestRaw.Schemas.OemResponse;
type TestSpecification = TestRequestRaw.Schemas.Specification;

export const CompetitorCompanySearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<CompetitorCompany>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export const CountrySearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<CountryResponse> & RefAttributes<{ reset: () => void }>
>;

export const CustomerSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<CustomerResponse> & RefAttributes<{ reset: () => void }>
>;

export const LaboratoriesSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<Laboratory>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export const NartsSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<NartResponse>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export const ProductNamesSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<ProductNameResponse>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export const BaseProductsSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteProps<BaseProductResponse>, TextFieldProps> & RefAttributes<{ reset: () => void }>
>;

export const OemSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<Oem> & RefAttributes<{ reset: () => void }>
>;

export const OpportunityProductsAutocomplete = CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteMultipleProps<OpportunityProductResponse>, TextFieldProps> &
    RefAttributes<{ reset: () => void }>
>;

export const ProductsAutocomplete = CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
  MergedProps<
    CustomSearchAutocompleteMultipleProps<
      ProductReferenceResponse & CompetitorProductReferenceResponse & PrototypeProductReferenceResponse
    >,
    TextFieldProps
  > &
    RefAttributes<{ reset: () => void }>
>;

export const SearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<string> & RefAttributes<{ reset: () => void }>
>;

export const TestMethodSearchMultipleAutocomplete = CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteMultipleProps<MinimalTestMethod>, TextFieldProps> &
    RefAttributes<{ reset: () => void }>
>;

export const TestSpecificationSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<TestSpecificationReference> & RefAttributes<{ reset: () => void }>
>;

export const TestSpecificationSearchMultipleAutocomplete =
  CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
    MergedProps<CustomSearchAutocompleteMultipleProps<TestSpecification>, TextFieldProps> &
      RefAttributes<{ reset: () => void }>
  >;

export const UserSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<UserReferenceResponse> & RefAttributes<{ reset: () => void }>
>;

export const AssignableUsersMultipleAutocomplete = CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
  MergedProps<
    CustomSearchAutocompleteMultipleProps<Required<LaboratoryUserResponse | NotificationListUserResponse>>,
    TextFieldProps
  > &
    RefAttributes<{ reset: () => void }>
>;

export const UsersSearchMultipleAutocomplete = CustomSearchAutocompleteMultiple as ForwardRefExoticComponent<
  MergedProps<CustomSearchAutocompleteMultipleProps<Required<UserReferenceResponse>>, TextFieldProps> &
    RefAttributes<{ reset: () => void }>
>;

export const LabAndUsersSearchAutocomplete = CustomSearchAutocomplete as ForwardRefExoticComponent<
  CustomSearchAutocompleteProps<LaboratoryResponse | UserReferenceDefault> & RefAttributes<{ reset: () => void }>
>;
